import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { HotelFilter } from 'models/hotelFilter';
import { LogicalFare } from 'models/logicalFare';
import { TravelArrangerUsersAllowed } from 'services/userService';

export type HotelsSearchRequest = {
  locationId: number;
  destinationType: string;
  destinationPoint?: string;
  checkIn: string;
  checkOut: string;
  traveler?: TravelArrangerUsersAllowed;
  currencyCode: string;
  countryId: string;
  sessionToken: string;
  rooms: [{ adults: 1 }];
  includeHotelInfo: boolean;
  includeRooms: boolean;
  maxResults: number;
  branchCompany?: GetAllBillingCompanyResponse;
};

export interface HotelsSearchResponse {
  results: HotelsResultResponse[];
  searchId: string;
  resultsAvailableUntil: Date;
  resultsCount: number;
  distanceRestriction: 'Domestic' | 'International';
  lowestLogicalFareList?: LogicalFare[];
}

export enum HotelsResultRequestOrderCriteriaEnum {
  PRICE = 'PRICE',
  RECOMENDATION = 'RECOMENDATION',
  CATEGORY = 'CATEGORY',
}

export interface HotelsResultRequest extends HotelFilter {
  userId: string;
  travelArrangerUserId?: string;
  searchId: string;
  resultCountLowerBound: number;
  resultCountUpperBound: number;
  orderCriteria: HotelsResultRequestOrderCriteriaEnum;
  sessionToken: string;
  orderDesc: boolean;
  includeRooms: boolean;
  distanceRestriction: 'Domestic' | 'International';
}

export interface HotelsResultResponse {
  checkinDate: string;
  checkoutDate: string;
  hotelName: string;
  hotelCode: string;
  hotelProvider: string;
  destination: string;
  category: number;
  address: string;
  city: string;
  thumbnail: string;
  images: string[];
  latitude: number;
  longitude: number;
  ammenities: string;
  preferenceOrder: number;
  bestVal: boolean;
  optionId: number;
  priceFrom: number;
  currencyCode: string;
  isPreApproved: boolean;
  breakRulesMessage?: string[];
  roomRates: {
    price: {
      taxes: number;
      total: number;
      amount: number;
      fees: number;
      surcharges: number;
      discountAmount: number;
      commissionAmount: number;
      currencyCode: string;
    };
    refundableType: number;
    roomIds: number[];
    rateId: string;
  }[];
  rooms: {
    roomId: number;
    roomCode: string;
    description: string;
    adults: number;
    children: number;
    boardCode: string;
    boardDescription: string;
  }[];
}
